import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client.service";
var GuestAdjustmentService = /** @class */ (function () {
    function GuestAdjustmentService(http) {
        this.http = http;
        this.server = environment.server;
        this.baseUrl = this.server + "/api/wallet/guest";
    }
    GuestAdjustmentService.prototype.creditGuestWallet = function (requestBody) {
        return this.http.post(this.baseUrl + "/wallet/credit", requestBody).pipe(catchError(this.handleError));
    };
    GuestAdjustmentService.prototype.debitGuestWallet = function (requestBody) {
        return this.http.post(this.baseUrl + "/wallet/debit", requestBody).pipe(catchError(this.handleError));
    };
    GuestAdjustmentService.prototype.getTransactionsByOrder = function (profileId, orderId) {
        return this.http.get(this.server + "/api/wallet/guest/" + encodeURIComponent(profileId) + "/walletTransactions?orderId=" + encodeURIComponent(orderId) + "&limit=50")
            .pipe(catchError(this.handleError));
    };
    GuestAdjustmentService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error("Backend returned code " + error.status + ", body was: " + error.error);
        }
        return throwError(error);
    };
    GuestAdjustmentService.ngInjectableDef = i0.defineInjectable({ factory: function GuestAdjustmentService_Factory() { return new GuestAdjustmentService(i0.inject(i1.MyHttpClient)); }, token: GuestAdjustmentService, providedIn: "root" });
    return GuestAdjustmentService;
}());
export { GuestAdjustmentService };
